export const AvailabilityKind = {
    FORBIDDEN: 'FORBIDDEN',
    UNDESIRED: 'UNDESIRED',
    PREFERRED: 'PREFERRED',
};
/** Значення в порядку оголошення в схемі. */
export const AVAILABILITY_KIND_VALUES = ['FORBIDDEN', 'UNDESIRED', 'PREFERRED'];
export const AVAILABILITY_KIND_LABELS = {
    FORBIDDEN: 'Заборонено',
    UNDESIRED: 'Небажано',
    PREFERRED: 'Бажано',
};
export const AVAILABILITY_KIND_TONES = {
    FORBIDDEN: 'danger',
    UNDESIRED: 'warning',
    PREFERRED: 'success',
};
//# sourceMappingURL=availability-kind.js.map